import { useState } from 'react';
import { getContentType } from '../../../Utils/helper';
import { WeekCardBox } from './styled';
import { fireClickedCardEvent } from '../../../Utils/useFirebase';

export default function WeekCard(props) {
  let { weekData, index, sectionId, length, heading } = props;
  const [weekCardSignal, setWeekCardSignal] = useState(' ');
  return (
    <>
      <WeekCardBox
        id={
          index == 0
            ? `${sectionId}first`
            : index == length - 1
              ? `${sectionId}last`
              : `productCards${index}`
        }
        className={weekCardSignal}
        onClick={() => {
          fireClickedCardEvent(
            heading,
            weekData?.text,
            getContentType(),
            weekData?.week,
            null,
            weekData?.deeplinkValue,
          );
          setWeekCardSignal('weekCardOpacity');
        }}
      >
        <span className="title">{weekData?.text}</span>
        <img
          src={weekData?.image}
          srcSet={`${weekData?.image}?tr=w-50,q-80 50w, ${weekData?.image}?tr=w-50,q-80 50w`}
          sizes="50px"
          alt="weekImage"
          loading="lazy"
        />
        <span className="weekNumber">{weekData?.week}</span>
      </WeekCardBox>
    </>
  );
}
